export default "__VITE_ASSET__BNb262nE__"